"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceDescription = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const DataSourceDescription = ({ dataSourceName, docsLink, hasRequiredFields = true, className }) => {
    const theme = (0, ui_1.useTheme2)();
    const styles = {
        container: (0, css_1.css)({
            p: {
                margin: 0,
            },
            'p + p': {
                marginTop: theme.spacing(2),
            },
        }),
        text: (0, css_1.css)(Object.assign(Object.assign({}, theme.typography.body), { color: theme.colors.text.secondary, a: (0, css_1.css)({
                color: theme.colors.text.link,
                textDecoration: 'underline',
                '&:hover': {
                    textDecoration: 'none',
                },
            }) })),
    };
    return (react_1.default.createElement("div", { className: (0, css_1.cx)(styles.container, className) },
        react_1.default.createElement("p", { className: styles.text },
            "Before you can use the ",
            dataSourceName,
            " data source, you must configure it below or in the config file. For detailed instructions,",
            ' ',
            react_1.default.createElement("a", { href: docsLink, target: "_blank", rel: "noreferrer" }, "view the documentation"),
            "."),
        hasRequiredFields && (react_1.default.createElement("p", { className: styles.text },
            react_1.default.createElement("i", null, "Fields marked with * are required")))));
};
exports.DataSourceDescription = DataSourceDescription;
//# sourceMappingURL=DataSourceDescription.js.map